import { useCallback } from "react";

import { useSidebar } from "../ui/sidebar";

/**
 * Hook to close the sidebar on mobile after navigation
 * @param name - The name of the sidebar to close
 * @returns A function to close the sidebar on mobile after navigation
 */
export const useSidebarMobileClick = (name: string) => {
  const { isMobile, setOpenMobile, openMobile } = useSidebar(name);

  return useCallback(() => {
    // Close sidebar on mobile after navigation
    if (isMobile && openMobile) {
      setOpenMobile(false);
    }
  }, [isMobile, openMobile, setOpenMobile]);
};
